import React, { memo } from 'react';
import classNames from 'classnames/bind';
import { ExpandingPanel } from '@beef/ui-kit';
import { getContent } from "../FaqMain";
import style from "./styles.module.pcss";
import { SEO_TYPE_ANSWER } from "../constants";
var cn = classNames.bind(style);
export var ExpandingContent = /*#__PURE__*/memo(function (_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    content = _ref.content,
    onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(ExpandingPanel, {
    onClick: onClick,
    size: "size4-m",
    tagType: "h2",
    title: /*#__PURE__*/React.createElement("span", {
      itemProp: "name"
    }, title),
    "data-t-id": "FAQ-ExpandingContent"
  }, (content === null || content === void 0 ? void 0 : content.length) > 0 && content.map(function (contentItem, contentIndex) {
    return /*#__PURE__*/React.createElement("section", {
      className: cn('section'),
      itemProp: "acceptedAnswer",
      itemScope: true,
      itemType: SEO_TYPE_ANSWER,
      key: +contentIndex
    }, contentItem.map(function (part, partIndex) {
      return /*#__PURE__*/React.createElement("div", {
        className: cn('section-block'),
        key: +partIndex
      }, getContent(part));
    }));
  }));
});